// Mindfield/eSense eGenius default brand color, mirrored by the
// --brand-primary-color CSS custom property (see :root in styles.scss).
// Runtime TS consumers (chart color config, layout config) that can't use
// CSS custom properties directly should import this constant so there is
// one source of truth pending per-tenant override wiring.
export const BRAND_PRIMARY_COLOR = '#17214b';
